import { render, staticRenderFns } from "./section6.vue?vue&type=template&id=3c49ddcb&scoped=true"
import script from "./section6.vue?vue&type=script&lang=js"
export * from "./section6.vue?vue&type=script&lang=js"
import style0 from "./section6.vue?vue&type=style&index=0&id=3c49ddcb&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c49ddcb",
  null
  
)

export default component.exports